import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { BinIcon2, EditIcon2 } from "../../../images/icons/icons";

const BenefitsList = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { addonBenefits, addonBenefitsLoading } = useSelector(
    (state) => state.plans
  );

  const handleDeleteBenefit = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/addoncat/benefits/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Benefit deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Cannot delete benefit!");
          }
        } catch (error) {
          toast.error(error?.message || "Failed to delete benefit");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to delete this benefit?`
      );
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "category_name",
      text: "Category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-badge ${
              row?.status === "active" ? "tb-badge-success" : "tb-badge-stuck"
            }`}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit_benefit",
                rowData: row,
              }))
            }
          >
            <EditIcon2 />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDeleteBenefit(filters);
            }}
          >
            <BinIcon2 />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="common-table-container mt15">
      <CommonTable
        tableData={addonBenefits?.data || []}
        tablePagination={addonBenefits?.pagination || []}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={addonBenefitsLoading}
      />
    </div>
  );
};

export default BenefitsList;
